require('./bootstrap');
require('select2');
require('./timepicker');
require('corejs-typeahead');
require('jquery-colorbox');
require('bootstrap-tagsinput');
import Dropzone from 'dropzone';
import Cropper from 'cropperjs';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import 'jquery-ui/ui/widgets/sortable';

var Bloodhound = require('bloodhound-js');


Dropzone.autoDiscover = false;

var markers = [],
    circles = [],
    infoWindows = {},
    serviceAreas = [],
    servedZips = [],
    timeout = null,
    radiusSelect = false,
    mapLoaded = false,
    markerPush = true,
    openedAsPopup = false,
    fetchedZipList = false,
    bloodhoundZips = false,
    typedBeforeMarker = false,
    map;



function approvePhoneNumberCharacter(event, element) {
    let allowedChars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '-', '+', '(', ')', '/', '\\', ' '];
    let lastCharacter = event.originalEvent.key;
    let approved = allowedChars.includes(lastCharacter);
    let elementId = $(element).attr('id');

    if (!approved) {
        // let errorElement2 = '<span id="invalid'+elementId+'CharError2" class="invalid-feedback d-block" role="alert"><strong>Available characters: 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, (), +, -, /, \\, whitespace</strong></span>';
        // if (!$('#invalid'+elementId+'CharError2').length)
        //     $(errorElement2).insertAfter(element);

        let errorElement1 = '<span id="invalid' + elementId + 'CharError1" class="invalid-feedback d-block" role="alert"><strong>Invalid character</strong></span>';
        if (!$('#invalid' + elementId + 'CharError1').length)
            $(errorElement1).insertAfter(element);

        setTimeout(
            function () {
                $('#invalid' + elementId + 'CharError1').remove();
                // $('#invalid'+elementId+'CharError2').remove();
            }, 2000);

        event.preventDefault();
    }
}

(function ($) {
    $(document).ready(function () {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        // $('[data-toggle="popover"]').popover({trigger: 'focus'});
        $('[data-toggle="popover"]').popover();

        $('.tooltip-bt').tooltip({boundary: 'window'})


        $('#analytics-table').on('click', 'th.sortable', function () {
            var sortBy = $(this).data('sort');
            
            var currentSortBy = $('input#sortBy').val();
            var currentSortDir = $('input#sortDir').val();
            console.log(currentSortBy,currentSortDir);
            if(sortBy && currentSortBy){
                if(sortBy == currentSortBy){
                    if(currentSortDir == 'Desc')
                        $('input#sortDir').val('Asc');
                    else
                        $('input#sortDir').val('Desc');

                }else{
                    $('input#sortBy').val(sortBy);
                }


                setTimeout(function() { 
                    $('button#search-form-button').trigger('click');
                }, 400);

            }

            return false;
        });


        if ($('#check-information').length > 0) {

            $("#school_name").on('focusout', function (e) {

                var schoolName = $(this).val();
                $('#schools-lists-exists').find('.partial-overlay').addClass('showed');

                $.ajax({
                    type: "POST",
                    url: "/check-school-exist",
                    data: {'schoolName': schoolName},
                    success: function (data) {
                        if (data.length <= 0) {
                            $('#schools-lists-claim')
                                .html('<p><em>No schools found with that name. Continue with registration process and add your school.</em></p>')
                                .promise().done(function () {
                                $('#schools-lists-exists').find('.partial-overlay').removeClass('showed');
                            });
                        } else {
                            setTimeout(function () {
                                $('#schools-lists-claim').html(data).promise().done(function () {

                                    $('#schools-lists-exists').find('.partial-overlay').removeClass('showed');
                                });
                            }, 200)
                        }
                    },
                    error: function (data) {

                        $('#schools-lists-exists').find('.partial-overlay').removeClass('showed');


                    }
                });

                return false;

            });

        }

        function isURL(str) {
            let urlRegex = '^(?!mailto:)(?:(?:http|https)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost|www.)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$';
            let url = new RegExp(urlRegex, 'i');
            return str.length < 2083 && url.test(str);
        }

        $('#videos')
            .on('keyup', '#register-video-input', function () {
                if ($(this).val() != '') {
                    $('#register-has-video').prop("checked", true);
                } else {
                    $('#register-has-video').prop("checked", false);
                }
            })
            .on('focusout', '#register-video-input', function () {
                let link = $(this).val();
                if (!isURL(link.trim()) || !link.includes('embed')){
                    $(this).addClass('is-invalid');
                    $.append_notification('error', 'Please provide valid You Tube Embed link <br /><small>ex.  https://www.youtube.com/embed/-example</small>. <br/> <small><a style="color:#fff; position:relative;width:auto"  href="https://support.google.com/youtube/answer/171780" target="_blank">See how you can do it here</a></small>');
                    //jQuery.jAlert('Please provide valid facebook link', 'Invalid Facebook Link');
                } else {
                    $(this).removeClass('is-invalid');
                }
            });

        $('#profiles')
            .on('keyup', '#register-website-input', function () {
                if ($(this).val() != '') {
                    $('#register-has-website').prop("checked", true);
                } else {
                    $('#register-has-website').prop("checked", false);
                }
            })
            .on('keyup', '#register-facebook-input', function () {
                if ($(this).val() != '') {
                    $('#register-has-facebook').prop("checked", true);
                } else {
                    $('#register-has-facebook').prop("checked", false);
                }
            })
            .on('keyup', '#register-twitter-input', function () {
                if ($(this).val() != '') {
                    $('#register-has-twitter').prop("checked", true);
                } else {
                    $('#register-has-twitter').prop("checked", false);
                }
            })
            .on('keyup', '#register-instagram-input', function () {
                if ($(this).val() != '') {
                    $('#register-has-instagram').prop("checked", true);
                } else {
                    $('#register-has-instagram').prop("checked", false);
                }
            })
            .on('focusout', '#register-website-input', function () {
                let link = $(this).val();
                if (!isURL(link.trim())){
                    $(this).addClass('is-invalid');
                    $.append_notification('error', 'Please provide valid link <br /><small>ex.  https://example.com</small>');
                    //jQuery.jAlert('Please provide valid link', 'Invalid Link');
                } else {
                    $(this).removeClass('is-invalid');
                }
            })
            .on('focusout', '#register-facebook-input', function () {
                let link = $(this).val();
                if (!isURL(link.trim()) || !link.includes('facebook')){
                    $(this).addClass('is-invalid');
                    $.append_notification('error', 'Please provide valid facebook link <br /><small>ex.  https://facebook.com/example</small>');
                    //jQuery.jAlert('Please provide valid facebook link', 'Invalid Facebook Link');
                } else {
                    $(this).removeClass('is-invalid');
                }
            })
            .on('focusout', '#register-twitter-input', function () {
                let link = $(this).val();
                if (!isURL(link.trim()) || !link.includes('twitter')){
                    $(this).addClass('is-invalid');
                    $.append_notification('error', 'Please provide valid twitter link <br /><small>ex.  https://twitter.com/example</small>');
                    //jQuery.jAlert('Please provide valid twitter link', 'Invalid Twitter Link');
                } else {
                    $(this).removeClass('is-invalid');
                }
            })
            .on('focusout', '#register-instagram-input', function () {
                let link = $(this).val();
                if (!isURL(link.trim()) || !link.includes('instagram')){
                    $(this).addClass('is-invalid');
                    $.append_notification('error', 'Please provide valid instagram link <br /><small>ex.  https://instagram.com/example</small>');
                    //jQuery.jAlert('Please provide valid instagram link', 'Invalid Instagram Link');
                } else {
                    $(this).removeClass('is-invalid');
                }
            });


        $('#register-school-form-steps')
            .on('keypress', '#phone', function (event) {
                approvePhoneNumberCharacter(event, this);
            })
            .on('keypress', '#phoneOne', function (event) {
                approvePhoneNumberCharacter(event, this);
            })
            .on('keypress', '#phoneTwo', function (event) {
                approvePhoneNumberCharacter(event, this);
            })
            .on('keypress', '#fax', function (event) {
                approvePhoneNumberCharacter(event, this);
            });


        if ($('#tutorial-display').length > 0) {


            $("#remove-tutorial-ajax").on('click', function (e) {
                e.preventDefault();

                $.ajax({
                    type: "POST",
                    url: "/disable-tutorial",
                    data: {},
                    success: function (data) {

                        window.location.reload(true);

                    },
                    error: function (data) {
                        window.location.reload(true);

                    }
                });

                return false;

            });


        }


        $("#help-center-float").on('click', function (e) {

            e.preventDefault();
            var loaderHtml = $('#loader-content').html();
            $('#help-center-opener').html(loaderHtml).addClass('opened');

            $.ajax({
                type: "POST",
                url: "/open-help-center",
                data: {},
                success: function (data) {

                    setTimeout(function () {
                        $('#help-center-opener').html(data).promise().done(function () {
                            openedAsPopup = true;
                            var closeBtn = '<div class="help-main-close-btn"><a href="javascript:;" id="close-btn-help-center"><i class="fas fa-minus"></i></a></div>';
                            $(closeBtn).insertAfter($('#help-center-opener').find('#help-center-button'));

                            $.helpCenterEvents();
                        });
                    }, 1000)
                    //

                },
                error: function (data) {

                    window.location.href = '/help-center';


                }
            });

            return false;

        });

        if ($('#help-center-section').length > 0) {
            $.helpCenterEvents();
        }


        if ($('#notification_content').length > 0 && $('#notification_content').find('.notification').length > 0) {
            $.each($('#notification_content').find('.notification'), function (i, k) {
                $.hide_notification($(k));
            })
        }


        if ($('#mapLocation').length > 0) {

            if ($('#display-address-field').find('input#latitude').length > 0) {
                var nearlatitudeSearch = $('#display-address-field').find('input#latitude').val();
            }
            if ($('#display-address-field').find('input#longitude').length > 0) {
                var nearlongitudeSearch = $('#display-address-field').find('input#longitude').val();
            }

            $('#serviceAreaSelect').on('beforeItemAdd', function (event) {

                var itemToString = (event.item.toString().length < 5)? '0'+event.item.toString() : event.item.toString();

                var inFetched = fetchedZipList.filter(el => el.text.toString() === itemToString);
                var errorShow = false;
                if ($(inFetched).length > 0) {
                    var item = inFetched[0];

                    if (item) {

                        if ($('#serviceArea').find('input#serviceArea-' + item.text).length > 0) {

                        } else {
                            var inputField = '<input type="hidden" id="serviceArea-' + item.text + '" name="serviceArea[]" value="' + item.value + '" data-zip="' + item.text + '" data-zcta="' + item.zcta_id + '" />';
                            $('#serviceArea').append(inputField);

                            servedZips.push(item.text.toString());

                            if (serviceAreas.length > 0) {
                                map.data.forEach(function (feature) {
                                    if (feature.getProperty("Id") == item.zcta_id) {
                                        map.data.overrideStyle(feature, {strokeColor: '#E63946', fillColor: '#E63946'})
                                    }
                                });
                            }

                        }
                    }

                } else {
                    if (errorShow) {

                    } else {
                        errorShow = true;
                        // $.append_notification('error', 'Wrong Zip Code or Zip Code is more than 25 miles away from your Driving School!');
                    }
                    event.cancel = true;
                }

            });

            $('#serviceAreaSelect').on('beforeItemRemove', function (event) {

                var itemToString = (event.item.toString().length < 5)? '0'+event.item.toString() : event.item.toString();

                if ($('#serviceArea').find('input#serviceArea-' + itemToString).length > 0) {
                    $('#serviceArea').find('input#serviceArea-' + itemToString).remove();
                }

                var inFetched = fetchedZipList.filter(el => el.text.toString() === itemToString);
                if ($(inFetched).length > 0) {
                    var item = inFetched[0];

                    if (item) {
                        if (serviceAreas.length > 0) {
                            map.data.forEach(function (feature) {
                                if (feature.getProperty("Id") == item.zcta_id) {
                                    map.data.overrideStyle(feature, {strokeColor: '#457B9D', fillColor: '#457B9D'})
                                }
                            });

                        }
                    }


                }

            });

            if (nearlatitudeSearch && nearlongitudeSearch) {

                $.when($.initializeBloodhound(nearlatitudeSearch, nearlongitudeSearch)).then(function () {
                    $.when($.loadTagsinput()).then(function () {
                        var previousServiceArea = $('#serviceArea').find('input');

                        if ($(previousServiceArea).length > 0) {
                            $.each(previousServiceArea, function (i, k) {
                                if ($(k).data('zip')) {
                                    $('#serviceAreaSelect').tagsinput('add', $(k).data('zip'));
                                    servedZips.push($(k).data('zip').toString());
                                }
                            });
                        }

                    });
                });


            }


            var typingTimer;
            var doneTypingInterval = 2000;

            $('input#displayAddress').on('keyup', function () {
                clearTimeout(typingTimer);
                typingTimer = setTimeout(doneTyping, doneTypingInterval);
            });

            $('input#displayAddress').on('keydown', function () {
                clearTimeout(typingTimer);
            });

            function doneTyping() {
                //do something
                var mapDiv = $('.map');
                var queryAddress = $('input#displayAddress').val();

                setTimeout(function () {
                    $('#mapLocation').find('#mapQueryField').val(queryAddress);
                    $('.map-container').removeClass('map-not-showed');
                    $('#serviceAreaInputsHolder').removeClass('service-area-not-showed');
                    load_map($(mapDiv).attr('id'));

                    if (queryAddress)
                        query_map($(mapDiv).attr('id'), queryAddress);


                }, 800);

            }

            if ($('#mapLocation').hasClass('map-init-load')) {
                setTimeout(function () {
                    var mapDiv = $('.map');
                    var queryAddress = $('#displayAddress').val();
                    $('.map-container').removeClass('map-not-showed');
                    $('#serviceAreaInputsHolder').removeClass('service-area-not-showed');
                    load_map($(mapDiv).attr('id'));
                    if (queryAddress)
                        query_map($(mapDiv).attr('id'), queryAddress);


                }, 800);

            }


            $("#pinLocationModalOpen").on('click', function () {

                if ($(this).closest('#display-address-field').find('input#latitude').length > 0) {
                    var nearlatitude = $(this).closest('#display-address-field').find('input#latitude').val();
                }
                if ($(this).closest('#display-address-field').find('input#longitude').length > 0) {
                    var nearlongitude = $(this).closest('#display-address-field').find('input#longitude').val();
                }

                if (nearlatitude && nearlongitude) {
                    var searchBy = {'schoolId': schoolId};
                    if (markerPush) {
                        markerPush = false;
                        $('#map-custom-loader').addClass('showed');
                        $(this).addClass('zctas_show');
                        $.ajax({
                            method: "post",
                            url: "/zip",
                            data: {'lat': nearlatitude, 'lng': nearlongitude},
                            success: function (data) {
                                if (data && data.zips) {
                                    var zctas = [];
                                    $.each(data.zips, function (i, k) {

                                        k.zips.some(function (e) {
                                            if (servedZips.indexOf(e.zip.toString()) >= 0)
                                                zctas.push(parseInt(k.id));
                                        });

                                        var serviceAreaPolygon = map.data.addGeoJson(
                                            k.json_shape
                                        );
                                        serviceAreas.push(k.id);

                                        map.data.setStyle(function (feature) {
                                            if (zctas.indexOf(feature.getProperty("Id")) >= 0)
                                                var color = '#E63946';
                                            else
                                                var color = '#457B9D';

                                            return {
                                                strokeColor: color,
                                                strokeOpacity: 0.8,
                                                strokeWeight: 1,
                                                fillColor: color,
                                                fillOpacity: 0.2
                                            };
                                        });


                                        map.data.addListener('click', function (event) {
                                            if (event.feature.getProperty("Id") == k.id) {
                                                if (k.zips.length) {
                                                    if ($('#serviceArea').find('input#serviceArea-' + k.zips[0].zip).length > 0) {
                                                        map.data.overrideStyle(event.feature, {
                                                            strokeColor: '#457B9D',
                                                            fillColor: '#457B9D'
                                                        })

                                                        $('#serviceArea').find('input#serviceArea-' + k.zips[0].zip).remove();
                                                        $('#serviceAreaSelect').tagsinput('remove', parseInt(k.zips[0].zip));

                                                    } else {
                                                        map.data.overrideStyle(event.feature, {
                                                            strokeColor: '#E63946',
                                                            fillColor: '#E63946'
                                                        })

                                                        var inputField = '<input type="hidden" id="serviceArea-' + k.zips[0].zip + '" name="serviceArea[]" value="' + k.zips[0].id + '" data-zip="' + k.zips[0].zip + '" data-zcta="' + k.zips[0].zcta_id + '" />';
                                                        $('#serviceArea').append(inputField);
                                                        $('#serviceAreaSelect').tagsinput('add', parseInt(k.zips[0].zip));
                                                    }
                                                }
                                            }

                                        });


                                    });
                                }

                                setTimeout(function () {
                                    $('#map-custom-loader').removeClass('showed');
                                }, 400);

                                if (typeof fetchedZipList !== 'undefined' && !fetchedZipList.length) {
                                    $.when($.initializeBloodhound(nearlatitude, nearlongitude)).then(function () {

                                    });
                                }


                            },
                            error: function (data) {
                                $.append_notification('error', 'Zip Codes could not be loaded. Please refresh your page and try again!');
                                $('#map-custom-loader').removeClass('showed');

                            }
                        });
                    } else {

                        map.data.forEach(function (feature) {
                            if (serviceAreas.includes(feature.getProperty("Id"))) {
                                map.data.remove(feature)
                            }
                        });
                        serviceAreas = [];
                        $(this).removeClass('zctas_show');

                        markerPush = true;
                    }
                }


            });


        }

        if ($('#sortable-instructurs').length > 0) {
            if ($('#sortable-instructurs').find('.dsl-info-wraper').length > 0) {
                setTimeout(function () {
                    $("#sortable-instructurs > .dsl-info-wraper").sortable({
                        update: function (event, ui) {
                            $.updateOrderSchoolInstructors();
                        }
                    });
                }, 400);
            }
        }

        if ($('#sortable-programs').length > 0) {
            if ($('#sortable-programs').find('.dsl-info-wraper').length > 0) {
                setTimeout(function () {
                    $("#sortable-programs > .dsl-info-wraper").sortable({
                        update: function (event, ui) {
                            $.updateOrderSchoolPrograms();
                        }
                    });
                }, 400);
            }
        }

        if ($('#content_data_objects').length > 0) {
            setTimeout(function () {
                $("#content_data_objects").sortable({
                    update: function (event, ui) {
                        $.updateOrderSchoolImages();
                    }
                });
            }, 400);

        }


        $("#remove-photo").on('click', function () {
            var validParent = $(this).closest('.upload-box-parent');
            var schoolId = $(this).closest('form').find('input[name="schoolsId"]');

            $(validParent).find('input[name="image"]').val('');
            $(validParent).find('img').attr('src', '/img/loader.svg');
            $.append_notification('success', 'Image was successfully removed');

            $(validParent).find('.dropzone-desc').removeClass('hidden');
            $(validParent).find('img').attr('src', '').addClass('hidden');
            $(this).closest('.image-delete-button').addClass('hidden');


        });

        var body = $('body');
        var contentWrapper = $('.content-wrapper');
        var scroller = $('.container-scroller');
        var footer = $('.footer');
        var sidebar = $('.sidebar');

        //Add active class to nav-link based on url dynamically
        //Active class can be hard coded directly in html file also as required

        function addActiveClass(element) {
            if (current === "") {
                //for root url
                if (element.attr('href').indexOf("dashboard") !== -1) {
                    element.parents('.nav-item').last().addClass('active');
                    if (element.parents('.sub-menu').length) {
                        element.closest('.collapse').addClass('show');
                        element.addClass('active');
                    }
                }
            } else {
                //for other url
                if (element.attr('href').indexOf(current) !== -1) {
                    element.parents('.nav-item').last().addClass('active');
                    if (element.parents('.sub-menu').length) {
                        element.closest('.collapse').addClass('show');
                        element.addClass('active');
                    }
                    if (element.parents('.submenu-item').length) {
                        element.addClass('active');
                    }
                }
            }
        }

        var current = location.pathname.split("/").slice(-1)[0].replace(/^\/|\/$/g, '');
        $('.nav li a', sidebar).each(function () {
            var $this = $(this);
            addActiveClass($this);
        })

        $('.horizontal-menu .nav li a').each(function () {
            var $this = $(this);
            addActiveClass($this);
        })

        //Close other submenu in sidebar on opening any

        sidebar.on('show.bs.collapse', '.collapse', function () {
            sidebar.find('.collapse.show').collapse('hide');
        });


        //Change sidebar and content-wrapper height
        applyStyles();

        function applyStyles() {
            //Applying perfect scrollbar
            if (!body.hasClass("rtl")) {
                if ($('.settings-panel .tab-content .tab-pane.scroll-wrapper').length) {
                    const settingsPanelScroll = new PerfectScrollbar('.settings-panel .tab-content .tab-pane.scroll-wrapper');
                }
                if ($('.chats').length) {
                    const chatsScroll = new PerfectScrollbar('.chats');
                }
                if (body.hasClass("sidebar-fixed")) {
                    if ($('#sidebar').length) {
                        var fixedSidebarScroll = new PerfectScrollbar('#sidebar .nav');
                    }
                }
            }
        }

        $('[data-toggle="minimize"]').on("click", function () {
            if ((body.hasClass('sidebar-toggle-display')) || (body.hasClass('sidebar-absolute'))) {
                body.toggleClass('sidebar-hidden');
            } else {
                body.toggleClass('sidebar-icon-only');
            }
        });


        //checkbox and radios
        $(".form-check label,.form-radio label").append('<i class="input-helper"></i>');

        //Horizontal menu in mobile
        $('[data-toggle="horizontal-menu-toggle"]').on("click", function () {
            $(".horizontal-menu .bottom-navbar").toggleClass("header-toggled");
        });
        // Horizontal menu navigation in mobile menu on click
        var navItemClicked = $('.horizontal-menu .page-navigation >.nav-item');
        navItemClicked.on("click", function (event) {
            if (window.matchMedia('(max-width: 991px)').matches) {
                if (!($(this).hasClass('show-submenu'))) {
                    navItemClicked.removeClass('show-submenu');
                }
                $(this).toggleClass('show-submenu');
            }
        })

        $(window).scroll(function () {
            if (window.matchMedia('(min-width: 992px)').matches) {
                var header = $('.horizontal-menu');
                if ($(window).scrollTop() >= 70) {
                    $(header).addClass('fixed-on-scroll');
                } else {
                    $(header).removeClass('fixed-on-scroll');
                }
            }
        });


        if ($(".js-example-basic-single").length) {
            $(".js-example-basic-single").select2();
        }
        if ($(".js-example-basic-multiple").length) {
            $(".js-example-basic-multiple").select2();
        }


        var schoolId = 0;
        if ($('input#schoolIdHidden').length > 0) {
            schoolId = $('input#schoolIdHidden').val();
        }

        if ($('#bigPhotoDropzone').length > 0) {
            var bigPhotoDropzone = new Dropzone("div#bigPhotoDropzone", {
                url: '/image/multiple',
                maxFiles: 1,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                },
                sending: function (file, xhr, formData) {
                    formData.append('order', '1');
                    formData.append('schoolId', schoolId);
                },
                transformFile: function (file, done) {

                    var myDropZone = this;
                    var elm = document.getElementById('school-upload-box');


                    var editor = document.createElement('div');
                    editor.id = 'editorHolder';
                    editor.style.position = 'absolute';
                    editor.style.left = 0;
                    editor.style.right = 0;
                    editor.style.top = 0;
                    editor.style.bottom = 0;
                    editor.style.zIndex = 9999;
                    editor.style.backgroundColor = '#000';


                    var confirm = document.createElement('button');
                    confirm.id = 'editorButton';
                    confirm.classList = ['btn btn-primary'];
                    confirm.style.position = 'absolute';
                    confirm.style.left = '10px';
                    confirm.style.top = '10px';
                    confirm.style.zIndex = 9999;
                    confirm.textContent = 'Crop Image';
                    confirm.addEventListener('click', function () {

                        var canvas = cropper.getCroppedCanvas({
                            width: 1200,
                            height: 675
                        });

                        canvas.toBlob(function (blob) {

                            myDropZone.createThumbnail(
                                blob,
                                myDropZone.options.thumbnailWidth,
                                myDropZone.options.thumbnailHeight,
                                myDropZone.options.thumbnailMethod,
                                false,
                                function (dataURL) {

                                    myDropZone.emit('thumbnail', file, dataURL);

                                    done(blob);
                                }
                            );

                        });


                        editor.parentNode.removeChild(editor);

                    });
                    editor.appendChild(confirm);


                    var image = new Image();
                    image.src = URL.createObjectURL(file);
                    editor.appendChild(image);


                    elm.appendChild(editor);

                    var cropper = new Cropper(image, {
                        aspectRatio: 16 / 9
                    });

                },
                success: function (file, response) {
                    var myDropZone = this;
                    if (response.status && response.path) {
                        var validParent = $('#bigPhotoDropzone').closest('.upload-box-parent');

                        // remove previous image added
                        var previousImageId = $(validParent).find('.remove_handle_school_image').attr('data-id');
                        if (previousImageId) {
                            $.ajax({
                                method: "DELETE",
                                url: "/image/" + previousImageId,
                                success: function (data) {

                                },
                                error: function (data) {
                                    // $.append_notification('error', 'Images was not be removed from School. Please refresh your page and try again!');
                                }
                            });

                        }

                        $(validParent).find('.dropzone-desc').addClass('hidden');
                        $(validParent).find('img').attr('src', response.url + "?v=" + Math.random()).removeClass('hidden');
                        $(validParent).find('.image-delete-button').removeClass('hidden');
                        $(validParent).find('.remove_handle_school_image').attr('data-id', response.id);

                        setTimeout(function () {
                            myDropZone.removeAllFiles();
                            $('#bigPhotoDropzone').find('.dz-preview').remove();
                        }, 1200);

                        $.append_notification('success', 'Image was successfully uploaded to server.');

                    } else {
                        $.append_notification('error', 'Image was not uploaded to server. Please refresh the page and try again.');
                    }

                },
                error: function (response) {
                    this.removeAllFiles();
                    if (response.xhr.status == 413) {
                        $.append_notification('error', 'Image Too Large');
                    } else if (response.xhr.statusText != '') {
                        $.append_notification('error', response.xhr.statusText);
                    }
                    $.append_notification('error', 'Something went wrong while uploading the image, please try again later!');
                }
            });

        }

        if ($('#smallPhotoDropzone-1').length > 0) {

            var smallPhotoDropzone1 = new Dropzone("div#smallPhotoDropzone-1", {
                url: '/image/multiple',
                maxFiles: 1,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                sending: function (file, xhr, formData) {
                    formData.append('order', '2');
                    formData.append('schoolId', schoolId);
                },
                transformFile: function (file, done) {

                    var myDropZone = this;
                    var elm = document.getElementById('school-upload-box');


                    var editor = document.createElement('div');
                    editor.id = 'editorHolder';
                    editor.style.position = 'absolute';
                    editor.style.left = 0;
                    editor.style.right = 0;
                    editor.style.top = 0;
                    editor.style.bottom = 0;
                    editor.style.zIndex = 9999;
                    editor.style.backgroundColor = '#000';


                    var confirm = document.createElement('button');
                    confirm.id = 'editorButton';
                    confirm.classList = ['btn btn-primary'];
                    confirm.style.position = 'absolute';
                    confirm.style.left = '10px';
                    confirm.style.top = '10px';
                    confirm.style.zIndex = 9999;
                    confirm.textContent = 'Crop Image';
                    confirm.addEventListener('click', function () {

                        var canvas = cropper.getCroppedCanvas({
                            width: 1200,
                            height: 675
                        });

                        canvas.toBlob(function (blob) {

                            myDropZone.createThumbnail(
                                blob,
                                myDropZone.options.thumbnailWidth,
                                myDropZone.options.thumbnailHeight,
                                myDropZone.options.thumbnailMethod,
                                false,
                                function (dataURL) {

                                    myDropZone.emit('thumbnail', file, dataURL);

                                    done(blob);
                                }
                            );

                        });


                        editor.parentNode.removeChild(editor);

                    });
                    editor.appendChild(confirm);


                    var image = new Image();
                    image.src = URL.createObjectURL(file);
                    editor.appendChild(image);


                    elm.appendChild(editor);

                    var cropper = new Cropper(image, {
                        aspectRatio: 16 / 9
                    });

                },
                success: function (file, response) {
                    var myDropZone = this;
                    if (response.status && response.path) {
                        var validParent = $('#smallPhotoDropzone-1').closest('.upload-box-parent');

                        // remove previous image added
                        var previousImageId = $(validParent).find('.remove_handle_school_image').attr('data-id');
                        if (previousImageId) {
                            $.ajax({
                                method: "DELETE",
                                url: "/image/" + previousImageId,
                                success: function (data) {

                                },
                                error: function (data) {
                                    // $.append_notification('error', 'Images was not be removed from School. Please refresh your page and try again!');
                                }
                            });

                        }

                        $(validParent).find('.dropzone-desc').addClass('hidden');
                        $(validParent).find('img').attr('src', response.url + "?v=" + Math.random()).removeClass('hidden');
                        $(validParent).find('.image-delete-button').removeClass('hidden');
                        $(validParent).find('.remove_handle_school_image').attr('data-id', response.id);

                        setTimeout(function () {
                            myDropZone.removeAllFiles();
                            $('#smallPhotoDropzone-1').find('.dz-preview').remove();
                        }, 1200);

                        $.append_notification('success', 'Image was successfully uploaded to server.');

                    } else {
                        $.append_notification('error', 'Image was not uploaded to server. Please refresh the page and try again.');
                    }

                },
                error: function (response) {
                    this.removeAllFiles();
                    if (response.xhr.status == 413) {
                        $.append_notification('error', 'Image Too Large');
                    } else if (response.xhr.statusText != '') {
                        $.append_notification('error', response.xhr.statusText);
                    }
                    $.append_notification('error', 'Something went wrong while uploading the image, please try again later!');
                }
            });

        }

        if ($('#smallPhotoDropzone-2').length > 0) {

            var smallPhotoDropzone2 = new Dropzone("div#smallPhotoDropzone-2", {
                url: '/image/multiple',
                maxFiles: 1,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                sending: function (file, xhr, formData) {
                    formData.append('order', '3');
                    formData.append('schoolId', schoolId);
                },
                transformFile: function (file, done) {

                    var myDropZone = this;
                    var elm = document.getElementById('school-upload-box');


                    var editor = document.createElement('div');
                    editor.id = 'editorHolder';
                    editor.style.position = 'absolute';
                    editor.style.left = 0;
                    editor.style.right = 0;
                    editor.style.top = 0;
                    editor.style.bottom = 0;
                    editor.style.zIndex = 9999;
                    editor.style.backgroundColor = '#000';


                    var confirm = document.createElement('button');
                    confirm.id = 'editorButton';
                    confirm.classList = ['btn btn-primary'];
                    confirm.style.position = 'absolute';
                    confirm.style.left = '10px';
                    confirm.style.top = '10px';
                    confirm.style.zIndex = 9999;
                    confirm.textContent = 'Crop Image';
                    confirm.addEventListener('click', function () {

                        var canvas = cropper.getCroppedCanvas({
                            width: 1200,
                            height: 675
                        });

                        canvas.toBlob(function (blob) {

                            myDropZone.createThumbnail(
                                blob,
                                myDropZone.options.thumbnailWidth,
                                myDropZone.options.thumbnailHeight,
                                myDropZone.options.thumbnailMethod,
                                false,
                                function (dataURL) {

                                    myDropZone.emit('thumbnail', file, dataURL);

                                    done(blob);
                                }
                            );

                        });


                        editor.parentNode.removeChild(editor);

                    });
                    editor.appendChild(confirm);


                    var image = new Image();
                    image.src = URL.createObjectURL(file);
                    editor.appendChild(image);


                    elm.appendChild(editor);

                    var cropper = new Cropper(image, {
                        aspectRatio: 16 / 9
                    });

                },
                success: function (file, response) {
                    var myDropZone = this;
                    if (response.status && response.path) {
                        var validParent = $('#smallPhotoDropzone-2').closest('.upload-box-parent');

                        // remove previous image added
                        var previousImageId = $(validParent).find('.remove_handle_school_image').attr('data-id');
                        if (previousImageId) {
                            $.ajax({
                                method: "DELETE",
                                url: "/image/" + previousImageId,
                                success: function (data) {

                                },
                                error: function (data) {
                                    // $.append_notification('error', 'Images was not be removed from School. Please refresh your page and try again!');
                                }
                            });

                        }

                        $(validParent).find('.dropzone-desc').addClass('hidden');
                        $(validParent).find('img').attr('src', response.url + "?v=" + Math.random()).removeClass('hidden');
                        $(validParent).find('.image-delete-button').removeClass('hidden');
                        $(validParent).find('.remove_handle_school_image').attr('data-id', response.id);

                        setTimeout(function () {
                            myDropZone.removeAllFiles();
                            $('#smallPhotoDropzone-2').find('.dz-preview').remove();
                        }, 1200);
                        $.append_notification('success', 'Image was successfully uploaded to server.');

                    } else {
                        $.append_notification('error', 'Image was not uploaded to server. Please refresh the page and try again.');
                    }

                },
                error: function (response) {
                    this.removeAllFiles();
                    if (response.xhr.status == 413) {
                        $.append_notification('error', 'Image Too Large');
                    } else if (response.xhr.statusText != '') {
                        $.append_notification('error', response.xhr.statusText);
                    }
                    $.append_notification('error', 'Something went wrong while uploading the image, please try again later!');
                }
            });

        }


        if ($('#smallPhotoDropzone-3').length > 0) {

            var smallPhotoDropzone3 = new Dropzone("div#smallPhotoDropzone-3", {
                url: '/image/multiple',
                maxFiles: 1,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                sending: function (file, xhr, formData) {
                    formData.append('order', '4');
                    formData.append('schoolId', schoolId);
                },
                transformFile: function (file, done) {

                    var myDropZone = this;
                    var elm = document.getElementById('school-upload-box');


                    var editor = document.createElement('div');
                    editor.id = 'editorHolder';
                    editor.style.position = 'absolute';
                    editor.style.left = 0;
                    editor.style.right = 0;
                    editor.style.top = 0;
                    editor.style.bottom = 0;
                    editor.style.zIndex = 9999;
                    editor.style.backgroundColor = '#000';


                    var confirm = document.createElement('button');
                    confirm.id = 'editorButton';
                    confirm.classList = ['btn btn-primary'];
                    confirm.style.position = 'absolute';
                    confirm.style.left = '10px';
                    confirm.style.top = '10px';
                    confirm.style.zIndex = 9999;
                    confirm.textContent = 'Crop Image';
                    confirm.addEventListener('click', function () {

                        var canvas = cropper.getCroppedCanvas({
                            width: 1200,
                            height: 675
                        });

                        canvas.toBlob(function (blob) {

                            myDropZone.createThumbnail(
                                blob,
                                myDropZone.options.thumbnailWidth,
                                myDropZone.options.thumbnailHeight,
                                myDropZone.options.thumbnailMethod,
                                false,
                                function (dataURL) {

                                    myDropZone.emit('thumbnail', file, dataURL);

                                    done(blob);
                                }
                            );

                        });


                        editor.parentNode.removeChild(editor);

                    });
                    editor.appendChild(confirm);


                    var image = new Image();
                    image.src = URL.createObjectURL(file);
                    editor.appendChild(image);


                    elm.appendChild(editor);

                    var cropper = new Cropper(image, {
                        aspectRatio: 16 / 9
                    });

                },
                success: function (file, response) {
                    var myDropZone = this;
                    if (response.status && response.path) {
                        var validParent = $('#smallPhotoDropzone-3').closest('.upload-box-parent');

                        // remove previous image added
                        var previousImageId = $(validParent).find('.remove_handle_school_image').attr('data-id');
                        if (previousImageId) {
                            $.ajax({
                                method: "DELETE",
                                url: "/image/" + previousImageId,
                                success: function (data) {

                                },
                                error: function (data) {
                                    // $.append_notification('error', 'Images was not be removed from School. Please refresh your page and try again!');
                                }
                            });

                        }

                        $(validParent).find('.dropzone-desc').addClass('hidden');
                        $(validParent).find('img').attr('src', response.url + "?v=" + Math.random()).removeClass('hidden');
                        $(validParent).find('.image-delete-button').removeClass('hidden');
                        $(validParent).find('.remove_handle_school_image').attr('data-id', response.id);

                        setTimeout(function () {
                            myDropZone.removeAllFiles();
                            $('#smallPhotoDropzone-3').find('.dz-preview').remove();
                        }, 1200);
                        $.append_notification('success', 'Image was successfully uploaded to server.');
                    } else {
                        $.append_notification('error', 'Image was not uploaded to server. Please refresh the page and try again.');
                    }

                },
                error: function (response) {
                    this.removeAllFiles();
                    if (response.xhr.status == 413) {
                        $.append_notification('error', 'Image Too Large');
                    } else if (response.xhr.statusText != '') {
                        $.append_notification('error', response.xhr.statusText);
                    }
                    $.append_notification('error', 'Something went wrong while uploading the image, please try again later!');
                }
            });

        }

        $('#upload-functionality').on('click', 'a.remove_handle_school_image', function () {
            var imageId = $(this).data('id');
            var that = $(this);
            if (imageId) {
                $.ajax({
                    method: "DELETE",
                    url: "/image/" + imageId,
                    success: function (data) {
                        $.append_notification('success', 'Image was successfully removed');

                        $(that).closest('.upload-box-parent').find('.dropzone-desc').removeClass('hidden');
                        $(that).closest('.upload-box-parent').find('img').attr('src', '').addClass('hidden');
                        $(that).closest('.image-delete-button').addClass('hidden');
                        $(that).attr('data-id', 0);
                        if ($(that).closest('.school-list-photos').length > 0)
                            $(that).closest('li').remove();

                    },
                    error: function (response) {
                        this.removeAllFiles();
                        if (response.xhr.status == 413) {
                            $.append_notification('error', 'Image Too Large');
                        } else if (response.xhr.statusText != '') {
                            $.append_notification('error', response.xhr.statusText);
                        }
                        $.append_notification('error', 'Images was not be removed from School. Please refresh your page and try again!');
                    }
                });
            }
            return false;
        });


        if ($('#listPhotosDropzone').length > 0) {

            var smallPhotoDropzone1 = new Dropzone("div#listPhotosDropzone", {
                url: '/image/multiple',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                sending: function (file, xhr, formData) {
                    formData.append('schoolId', schoolId);
                },
                transformFile: function (file, done) {

                    var myDropZone = this;
                    var elm = document.getElementById('school-upload-box');


                    var editor = document.createElement('div');
                    editor.id = 'editorHolder';
                    editor.style.position = 'absolute';
                    editor.style.left = 0;
                    editor.style.right = 0;
                    editor.style.top = 0;
                    editor.style.bottom = 0;
                    editor.style.zIndex = 9999;
                    editor.style.backgroundColor = '#000';


                    var confirm = document.createElement('button');
                    confirm.id = 'editorButton';
                    confirm.classList = ['btn btn-primary'];
                    confirm.style.position = 'absolute';
                    confirm.style.left = '10px';
                    confirm.style.top = '10px';
                    confirm.style.zIndex = 9999;
                    confirm.textContent = 'Crop Image';
                    confirm.addEventListener('click', function () {

                        var canvas = cropper.getCroppedCanvas({
                            width: 1200,
                            height: 675
                        });

                        canvas.toBlob(function (blob) {

                            myDropZone.createThumbnail(
                                blob,
                                myDropZone.options.thumbnailWidth,
                                myDropZone.options.thumbnailHeight,
                                myDropZone.options.thumbnailMethod,
                                false,
                                function (dataURL) {

                                    myDropZone.emit('thumbnail', file, dataURL);

                                    done(blob);
                                }
                            );

                        });


                        editor.parentNode.removeChild(editor);

                    });
                    editor.appendChild(confirm);


                    var image = new Image();
                    image.src = URL.createObjectURL(file);
                    editor.appendChild(image);


                    elm.appendChild(editor);

                    var cropper = new Cropper(image, {
                        aspectRatio: 16 / 9
                    });

                },
                success: function (file, response) {
                    var myDropZone = this;


                    if (response.status && response.path) {

                        if (response.order && response.order < 5) {
                            if (response.order == 4) {
                                var validParent = $(' #smallPhotoDropzone-3').closest('.upload-box-parent');
                                var validContent = $(' #smallPhotoDropzone-3');
                            } else if (response.order == 3) {
                                var validParent = $(' #smallPhotoDropzone-2').closest('.upload-box-parent');
                                var validContent = $(' #smallPhotoDropzone-2');
                            } else if (response.order == 2) {
                                var validParent = $(' #smallPhotoDropzone-1').closest('.upload-box-parent');
                                var validContent = $(' #smallPhotoDropzone-1');
                            } else {
                                var validParent = $('#bigPhotoDropzone').closest('.upload-box-parent');
                                var validContent = $('#bigPhotoDropzone');
                            }


                            // remove previous image added
                            var previousImageId = $(validParent).find('.remove_handle_school_image').attr('data-id');
                            if (previousImageId) {
                                $.ajax({
                                    method: "DELETE",
                                    url: "/image/" + previousImageId,
                                    success: function (data) {

                                    },
                                    error: function (data) {
                                        // $.append_notification('error', 'Images was not be removed from School. Please refresh your page and try again!');
                                    }
                                });

                            }

                            $(validParent).find('.dropzone-desc').addClass('hidden');
                            $(validParent).find('img').attr('src', response.url + "?v=" + Math.random()).removeClass('hidden');
                            $(validParent).find('.image-delete-button').removeClass('hidden');
                            $(validParent).find('.remove_handle_school_image').attr('data-id', response.id);

                            setTimeout(function () {

                                $(validContent).find('.dz-preview').remove();
                            }, 600);

                            $.append_notification('success', 'Image was successfully reordered & uploaded to server.');


                        } else {
                            if (schoolId) {
                                var searchBy = {'schoolId': schoolId};
                            } else
                                var searchBy = {};


                            $.ajax({
                                method: "post",
                                url: "/image/list-images",
                                data: searchBy,
                                success: function (data) {
                                    if (data) {
                                        $('#listImagesSchool').html(data);
                                        setTimeout(function () {
                                            $("#content_data_objects").sortable({
                                                update: function (event, ui) {
                                                    $.updateOrderSchoolImages();
                                                }
                                            });
                                        }, 400);


                                    }


                                },
                                error: function (data) {
                                    $.append_notification('error', 'Images could not be loaded. Please refresh your page and try again!');
                                    // $.removeOverlay($el);
                                    // window.location.reload(true);
                                }
                            });

                            var validParent = $('#listPhotosDropzone');

                            $.append_notification('success', 'Image was successfully uploaded to server.');

                        }

                    } else {
                        $.append_notification('error', 'Image was not uploaded to server. Please refresh the page and try again.');
                    }

                },
                error: function (response) {
                    this.removeAllFiles();
                    if (response.xhr.status == 413) {
                        $.append_notification('error', 'Image Too Large');
                    } else if (response.xhr.statusText != '') {
                        $.append_notification('error', response.xhr.statusText);
                    }
                    $.append_notification('error', 'Something went wrong while uploading the image, please try again later!');
                }
            });

        }


        if ($('#photoDropzone').length > 0) {

            var photoDropzone = new Dropzone("div#photoDropzone", {
                url: '/image',
                maxFiles: 1,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                sending: function (file, xhr, formData) {
                    formData.append('order', '1');
                    formData.append('schoolId', schoolId);
                    formData.append('type', 'location');
                },
                transformFile: function (file, done) {

                    var myDropZone = this;
                    var elm = document.getElementById('school-upload-box');


                    var editor = document.createElement('div');
                    editor.id = 'editorHolder';
                    editor.style.position = 'absolute';
                    editor.style.left = 0;
                    editor.style.right = 0;
                    editor.style.top = 0;
                    editor.style.bottom = 0;
                    editor.style.zIndex = 9999;
                    editor.style.backgroundColor = '#000';


                    var confirm = document.createElement('button');
                    confirm.id = 'editorButton';
                    confirm.classList = ['btn btn-primary'];
                    confirm.style.position = 'absolute';
                    confirm.style.left = '10px';
                    confirm.style.top = '10px';
                    confirm.style.zIndex = 9999;
                    confirm.textContent = 'Crop Image';
                    confirm.addEventListener('click', function () {

                        var canvas = cropper.getCroppedCanvas({
                            width: 1200,
                            height: 675
                        });

                        canvas.toBlob(function (blob) {

                            myDropZone.createThumbnail(
                                blob,
                                myDropZone.options.thumbnailWidth,
                                myDropZone.options.thumbnailHeight,
                                myDropZone.options.thumbnailMethod,
                                false,
                                function (dataURL) {

                                    myDropZone.emit('thumbnail', file, dataURL);

                                    done(blob);
                                }
                            );

                        });


                        editor.parentNode.removeChild(editor);

                    });
                    editor.appendChild(confirm);


                    var image = new Image();
                    image.src = URL.createObjectURL(file);
                    editor.appendChild(image);


                    elm.appendChild(editor);

                    var cropper = new Cropper(image, {
                        aspectRatio: 16 / 9
                    });

                },
                success: function (file, response) {
                    var myDropZone = this;
                    if (response.status && response.path) {
                        var validParent = $('#photoDropzone').closest('.upload-box-parent');

                        $(validParent).find('.dropzone-desc').addClass('hidden');
                        $(validParent).find('img').attr('src', response.url + "?v=" + Math.random()).removeClass('hidden');
                        $(validParent).find('.image-delete-button').removeClass('hidden');
                        $(validParent).find('input[name="image"]').val(response.path);

                        setTimeout(function () {
                            myDropZone.removeAllFiles();
                            $('#photoDropzone').find('.dz-preview').remove();
                        }, 1200);

                        $.append_notification('success', 'Image was successfully uploaded to server. Save the changes by clicking the "Save" button at the end of the page to update the changes.');

                    } else {
                        $.append_notification('error', 'Image was not uploaded to server. Please refresh the page and try again.');
                    }

                },
                error: function (response) {
                    this.removeAllFiles();
                    if (response.xhr.status == 413) {
                        $.append_notification('error', 'Image Too Large');
                    } else if (response.xhr.statusText != '') {
                        $.append_notification('error', response.xhr.statusText);
                    }
                    $.append_notification('error', 'Something went wrong while uploading the image, please try again later!');
                }
            });

        }


        if ($('#instructorPhotoDropzone').length > 0) {

            var instructorPhotoDropzone = new Dropzone("div#instructorPhotoDropzone", {
                url: '/image',
                maxFiles: 1,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                sending: function (file, xhr, formData) {
                    formData.append('order', '1');
                    formData.append('schoolId', schoolId);
                    formData.append('type', 'instructor');
                },
                transformFile: function (file, done) {

                    var myDropZone = this;
                    var elm = document.getElementById('school-upload-box');


                    var editor = document.createElement('div');
                    editor.id = 'editorHolder';
                    editor.style.position = 'absolute';
                    editor.style.left = 0;
                    editor.style.right = 0;
                    editor.style.top = 0;
                    editor.style.bottom = 0;
                    editor.style.zIndex = 9999;
                    editor.style.backgroundColor = '#000';


                    var confirm = document.createElement('button');
                    confirm.id = 'editorButton';
                    confirm.classList = ['btn btn-primary'];
                    confirm.style.position = 'absolute';
                    confirm.style.left = '10px';
                    confirm.style.top = '10px';
                    confirm.style.zIndex = 9999;
                    confirm.textContent = 'Crop Image';
                    confirm.addEventListener('click', function () {

                        var canvas = cropper.getCroppedCanvas({
                            width: 400,
                            height: 400
                        });

                        canvas.toBlob(function (blob) {

                            myDropZone.createThumbnail(
                                blob,
                                myDropZone.options.thumbnailWidth,
                                myDropZone.options.thumbnailHeight,
                                myDropZone.options.thumbnailMethod,
                                false,
                                function (dataURL) {

                                    myDropZone.emit('thumbnail', file, dataURL);

                                    done(blob);
                                }
                            );

                        });


                        editor.parentNode.removeChild(editor);

                    });
                    editor.appendChild(confirm);


                    var image = new Image();
                    image.src = URL.createObjectURL(file);
                    editor.appendChild(image);


                    elm.appendChild(editor);

                    var cropper = new Cropper(image, {
                        aspectRatio: 1 / 1
                    });

                },
                success: function (file, response) {
                    var myDropZone = this;
                    if (response.status && response.path) {
                        var validParent = $('#instructorPhotoDropzone').closest('.upload-box-parent');

                        $(validParent).find('.dropzone-desc').addClass('hidden');
                        $(validParent).find('img').attr('src', response.url + "?v=" + Math.random()).removeClass('hidden');
                        $(validParent).find('.image-delete-button').removeClass('hidden');
                        $(validParent).find('input[name="image"]').val(response.path);

                        if ($('#showSentButton').length > 0) {
                            $('#showSentButton').removeClass('d-none');
                        }

                        setTimeout(function () {
                            myDropZone.removeAllFiles();
                            $('#instructorPhotoDropzone').find('.dz-preview').remove();
                        }, 1200);

                        $.append_notification('success', 'Image was successfully uploaded to server. Save the changes by clicking the "Save" button at the end of the page to update the changes.');

                    } else {
                        $.append_notification('error', 'Image was not uploaded to server. Please refresh the page and try again.');
                    }

                },
                error: function (response) {
                    this.removeAllFiles();
                    if (response.xhr.status == 413) {
                        $.append_notification('error', 'Image Too Large');
                    } else if (response.xhr.statusText != '') {
                        $.append_notification('error', response.xhr.statusText);
                    }
                    $.append_notification('error', 'Something went wrong while uploading the image, please try again later!');
                }
            });

        }


        if ($('#publicDropzone').length > 0) {

            var photoDropzone = new Dropzone("div#publicDropzone", {
                url: '/public-image',
                maxFiles: 1,
                dataType: 'json',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                sending: function (file, xhr, formData) {
                    formData.append('order', '1');
                },
                transformFile: function (file, done) {

                    var myDropZone = this;
                    var elm = document.getElementById('school-upload-box');


                    var editor = document.createElement('div');
                    editor.id = 'editorHolder';
                    editor.style.position = 'absolute';
                    editor.style.left = 0;
                    editor.style.right = 0;
                    editor.style.top = 0;
                    editor.style.bottom = 0;
                    editor.style.zIndex = 9999;
                    editor.style.backgroundColor = '#000';


                    var confirm = document.createElement('button');
                    confirm.id = 'editorButton';
                    confirm.classList = ['btn btn-primary'];
                    confirm.style.position = 'absolute';
                    confirm.style.left = '10px';
                    confirm.style.top = '10px';
                    confirm.style.zIndex = 9999;
                    confirm.textContent = 'Crop Image';
                    confirm.addEventListener('click', function () {

                        var canvas = cropper.getCroppedCanvas({
                            width: 1200,
                            height: 675
                        });

                        canvas.toBlob(function (blob) {

                            myDropZone.createThumbnail(
                                blob,
                                myDropZone.options.thumbnailWidth,
                                myDropZone.options.thumbnailHeight,
                                myDropZone.options.thumbnailMethod,
                                false,
                                function (dataURL) {

                                    myDropZone.emit('thumbnail', file, dataURL);

                                    done(blob);
                                }
                            );

                        });


                        editor.parentNode.removeChild(editor);

                    });
                    editor.appendChild(confirm);


                    var image = new Image();
                    image.src = URL.createObjectURL(file);
                    editor.appendChild(image);


                    elm.appendChild(editor);

                    var cropper = new Cropper(image, {
                        aspectRatio: 16 / 9
                    });

                },
                success: function (file, response) {
                    var myDropZone = this;
                    if (response.status && response.path) {
                        var validParent = $('#publicDropzone').closest('.upload-box-parent');

                        $(validParent).find('.dropzone-desc').addClass('hidden');
                        $(validParent).find('img').attr('src', response.url + "?v=" + Math.random()).removeClass('hidden');
                        $(validParent).find('.image-delete-button').removeClass('hidden');
                        $(validParent).find('input[name="image"]').val(response.path);
                        $(validParent).find('input[name="image_id"]').val(response.id);

                        setTimeout(function () {
                            myDropZone.removeAllFiles();
                            $('#publicDropzone').find('.dz-preview').remove();
                        }, 1200);

                        $.append_notification('success', 'Image was successfully uploaded to server.');

                    } else {
                        $.append_notification('error', 'Image was not uploaded to server. Please refresh the page and try again.');
                    }

                },
                error: function (response) {
                    this.removeAllFiles();
                    if (response.xhr.status == 413) {
                        $.append_notification('error', 'Image Too Large');
                    } else if (response.xhr.statusText != '') {
                        $.append_notification('error', response.xhr.statusText);
                    }
                    $.append_notification('error', 'Something went wrong while uploading the image, please try again later!');
                }
            });

        }


        $('#sample1 input').ptTimeSelect();


        if ($('.add-more-social').length) {
            $('.add-more-social').on('click', 'a.btn', function () {

                var lastKey = $(this).attr('data-place');

                var newRowAdd = '<div class="row">' +
                    '<div class="col-2 col-sm-3">' +
                    '<div class="form-group">' +
                    '<div class="form-check">' +
                    '<label class="form-check-label no-input">' +
                    '<span class="ds-icon far fa-envelope"></span>' +
                    'Email' +
                    '<i class="input-helper"></i>' +
                    '</label>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="col-10 col-sm-9">' +
                    '<div class="form-group">' +
                    '<input type="text" class="form-control" placeholder="' + lastKey + '" name="emails[]" value="">' +
                    '</div>' +
                    '</div>' +
                    '</div>';


                $(newRowAdd).appendTo($('#emails'));
            });
        }


        if ($('#about').length > 0) {
            ClassicEditor
                .create(document.querySelector('#about'), {
                    toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote'],
                    heading: {
                        options: [
                            {model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph'},
                            {model: 'heading1', view: 'h3', title: 'Heading 1', class: 'ck-heading_heading3'},
                            {model: 'heading2', view: 'h4', title: 'Heading 2', class: 'ck-heading_heading4'},
                            {model: 'heading3', view: 'h5', title: 'Heading 3', class: 'ck-heading_heading5'}
                        ]
                    }
                    // plugins: [ Image, ImageToolbar, ImageCaption, ImageStyle ],
                    // image: {
                    //     toolbar: [ 'imageTextAlternative', '|', 'imageStyle:full', 'imageStyle:side' ]
                    // }
                })
                .then(editor => {
                    editor.model.document.on('change:data', () => {
                        var newdata = editor.getData();
                        $('#about').html(newdata);

                    });
                })
                .catch(error => {
                    console.log(error);
                });
        }

        if ($('#description').length > 0) {
            ClassicEditor
                .create(document.querySelector('#description'), {
                    toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote'],
                    heading: {
                        options: [
                            {model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph'},
                            {model: 'heading1', view: 'h3', title: 'Heading 1', class: 'ck-heading_heading3'},
                            {model: 'heading2', view: 'h4', title: 'Heading 2', class: 'ck-heading_heading4'},
                            {model: 'heading3', view: 'h5', title: 'Heading 3', class: 'ck-heading_heading5'}
                        ]
                    }
                    // plugins: [ Image, ImageToolbar, ImageCaption, ImageStyle ],
                    // image: {
                    //     toolbar: [ 'imageTextAlternative', '|', 'imageStyle:full', 'imageStyle:side' ]
                    // }
                })
                .then(editor => {
                    editor.model.document.on('change:data', () => {
                        var newdata = editor.getData();
                        $('#description').html(newdata);

                    });
                })
                .catch(error => {
                    console.log(error);
                });
        }


        if ($('.hourOperation').length > 0 && typeof operationHours !== 'undefined' && operationHours) {
            $('input.hourOperation').ptTimeSelect().on('change', function () {
                var changedValue = $(this).val();
                if (changedValue) {
                    if (changedValue.toLowerCase() == '12:00 am')
                        changedValue = '0:00 am';
                    if (changedValue.toLowerCase() == '12:15 am')
                        changedValue = '0:15 am';
                    if (changedValue.toLowerCase() == '12:30 am')
                        changedValue = '0:30 am';
                    if (changedValue.toLowerCase() == '12:45 am')
                        changedValue = '0:45 am';
                }


                if ($(this).prev('span').length > 0) {

                    if (changedValue && operationHours[changedValue.toLowerCase()]) {
                        $(this).prev('span').html(operationHours[changedValue.toLowerCase()]);
                        var dataDay = $(this).closest('.select-hour');
                        if ($(dataDay).length > 0) {
                            var checkForDay = $(dataDay).data('day');
                            if (checkForDay) {
                                $(dataDay).removeClass('not-set-hours');
                                $('.bi-working-days div[data-day="' + checkForDay + '"]').find('input').prop('checked', 'checked');
                            }

                        }
                    } else
                        $(this).prev('span').html('Not Set');

                }

            });

            $('input.day-choosen').on('change', function () {
                if ($(this).prop('checked')) {
                    var dataDay = $(this).closest('.check-day');
                    if ($(dataDay).length > 0) {
                        var checkForDay = $(dataDay).data('day');
                        if (checkForDay) {
                            $('.bi-open-hour div[data-day="' + checkForDay + '"]').removeClass('not-set-hours');
                            // $('.bi-open-hour div[data-day="'+checkForDay+'"]').find('input').val(' ');
                        }
                    }

                } else {
                    var dataDay = $(this).closest('.check-day');
                    if ($(dataDay).length > 0) {
                        var checkForDay = $(dataDay).data('day');
                        if (checkForDay) {
                            $('.bi-open-hour div[data-day="' + checkForDay + '"]').addClass('not-set-hours');
                            $('.bi-open-hour div[data-day="' + checkForDay + '"]').find('input').val(' ').trigger('change');
                        }
                    }
                }

            });
        }


        $('.edit-as-modal').on('show.bs.collapse', function (e) {
            var clicked = e.target,
                link = $(clicked).closest('.card-holder').find('.collapse-triggerer');
            if ($(link).length > 0) {
                $.ajax({
                    method: "get",
                    url: $(link).attr('href'),
                    success: function (data) {

                        $(clicked).find('.card-body').html(data);

                    },
                    error: function (data) {
                        $.append_notification('error', 'Could not load required content for Update!');

                    }
                });
            }

        })

        $('.colorbox-image').colorbox();


        $('.colorbox-edit-function').click(function () {
            var $this = $(this)
                , title = $this.attr('title')
                , href = $this.attr('href');

            $.colorbox({
                href: href,
                title: $this.attr('title'),
                iframe: true,
                inline: false,
                fixed: true,
                width: '98%',
                height: '95%',
                maxWidth: '640px',
                maxHeight: '720px',
                reposition: true,
                onOpen: function () {

                },
                onClosed: function () {
                    if ($('#school-init-form-important').length && $('#school-init-form-important-btn').length) {
                        $("#school-init-form-important-btn").trigger('click');
                    }

                }
            });


            return false;
        });
        $(document).bind('cbox_complete', function () {
            $('#cboxClose').html('<i class="fas fa-times"></i>');
        });


        $('form.jConfirm').on('submit', function function_name(e) {

            if ($(this).find('input.jCofirmed').length) {
                return true;
            } else {

                e.preventDefault(); // does not go through with the link.

                var $this = $(this);
                var message = 'Are you sure that you want to Delete this resourse?',
                    title = 'Confirm DELETE',
                    windowLocation = jQuery(this).attr('href'),
                    clickedElement = jQuery(this);

                if (message == undefined)
                    message = 'Confirm delete process';
                if (title == undefined)
                    title = "Confirm";

                $.alerts.okButton = "Delete";
                jQuery.jConfirm(message, title, function (data) {
                    if (data) {
                        var inputField = '<input type="hidden" name="jCofirmed" value="1" class="jCofirmed" />';


                        $($this).append(inputField).promise().done(function () {
                            $($this).submit()
                        });

                    }
                });

                return false;


                // body...
            }

        });


    });
})(jQuery);


$.initializeBloodhound = function (latSearch, lngSearch) {

    if (latSearch && lngSearch) {
        bloodhoundZips = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('text'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            initialize: false,
            prefetch: {
                url: '/zip?lat=' + latSearch + '&lng=' + lngSearch,
                filter: function (list) {
                    fetchedZipList = list;
                    return list;
                },
                cache: false
            }
        });

        return bloodhoundZips.initialize(true);
    } else
        return false;

}


$.loadTagsinput = function () {

    $('#serviceAreaSelect').tagsinput({
        typeaheadjs: {
            highlight: true,
            maxChars: 5,
            trimValue: true,
            freeInput: true,
            name: 'zips',
            displayKey: 'text',
            valueKey: 'text',
            source: bloodhoundZips.ttAdapter()
        }
    });

}


$.updateOrderSchoolInstructors = function () {

    var newImageOrder = {},
        images = $('#sortable-instructurs').find('.attached_instructor_id'),
        schoolId = $('#sortable-instructurs').find('.schoolId-field').val();

    $.each(images, function (i, k) {
        newImageOrder[i] = $(k).val();
    })

    setTimeout(function () {

        $.ajax({
            method: "post",
            url: "/instructor/reorder",
            data: {'instructors': newImageOrder, 'schoolId': schoolId},
            success: function (data) {
                $.append_notification('success', 'Instructors were successfully reordered!');

            },
            error: function (data) {
                $.append_notification('error', 'Instructors could not be reordered. Please refresh your page and try again!');
                // $.removeOverlay($el);
                // window.location.reload(true);
            }
        });


    }, 200);


}

$.updateOrderSchoolPrograms = function () {

    var newImageOrder = {},
        images = $('#sortable-programs').find('.attached_program_id'),
        schoolId = $('#sortable-programs').find('.schoolId-field').val();

    $.each(images, function (i, k) {
        newImageOrder[i] = $(k).val();
    })

    setTimeout(function () {

        $.ajax({
            method: "post",
            url: "/program/reorder",
            data: {'programs': newImageOrder, 'schoolId': schoolId},
            success: function (data) {
                $.append_notification('success', 'Programs or Classes were successfully reordered!');

            },
            error: function (data) {
                $.append_notification('error', 'Programs or Classes could not be reordered. Please refresh your page and try again!');
                // $.removeOverlay($el);
                // window.location.reload(true);
            }
        });


    }, 200);


}

$.updateOrderSchoolImages = function () {

    var newImageOrder = {},
        images = $('#content_data_objects').find('.attached_image_id');

    $.each(images, function (i, k) {
        newImageOrder[i] = $(k).val();
    })

    setTimeout(function () {

        $.ajax({
            method: "post",
            url: "/image/reorder",
            data: {'images': newImageOrder},
            success: function (data) {
                $.append_notification('success', 'Images were successfully reordered!');

                var firstImage = $('#content_data_objects').find('img').first();

                $('#schoolCoverImage').attr('src', $(firstImage).attr('src')).trigger('change');

            },
            error: function (data) {
                $.append_notification('error', 'Images could not be reordered. Please refresh your page and try again!');
                // $.removeOverlay($el);
                // window.location.reload(true);
            }
        });


    }, 200);


}


$.helpCenterEvents = function () {
    var stepShow = 1;
    $('#help-center-section').on('click', 'a.tab-link', function (e) {
        e.preventDefault();
        // First Hide all other tabs and remove link class
        $('#help-center-section').find('.tab-pane').removeClass('show').removeClass('active');
        $('#help-center-section').find('a.tab-link').removeClass('active').removeClass('mobile-opened').addClass('mobile-hide');

        var idShow = $(this).attr('href').replace("#", "");

        $('#help-center-section').find('div[id="' + idShow + '"]').tab('show');
        $(this).addClass('active').removeClass('mobile-hide').addClass('mobile-opened');

        $(this).next('.tab-pane').addClass('mobile-show');

        if ($(window).width() < 767 || openedAsPopup) {
            $('#help-center-title').hide();
            $('#help-center-button').show();
        }

        stepShow = 2;


        return false;
    })

    $('#help-center-section').on('click', 'a.hc-option-name', function (e) {
        e.preventDefault();
        // First Hide all other tabs and remove link class
        $(this).closest('.tab-pane').find('.collapse').removeClass('show').removeClass('mobile-show');
        $(this).closest('.tab-pane').find('a.hc-option-name').addClass('collapsed').removeClass('mobile-opened').addClass('mobile-hide');

        var idShow = $(this).attr('href').replace("#", "");

        $('#help-center-section').find('div[id="' + idShow + '"]').addClass('show').addClass('mobile-show');
        $(this).removeClass('collapsed').removeClass('mobile-hide').addClass('mobile-opened');

        $(this).closest('.tab-pane').prev('.tab-link').addClass('mobile-hide').removeClass('mobile-opened');
        stepShow = 3;

        if ($(window).width() < 767 || openedAsPopup) {
            $('#help-center-title').hide();
            $('#help-center-button').show();
        }

        return false;
    });

    $('#help-center-button').on('click', 'a#back-btn-help-center', function (e) {
        e.preventDefault();


        if (stepShow == 2) {
            var activePane = $('#help-center-section').find('.tab-pane.mobile-show');

            $(activePane).prev('a.tab-link').removeClass('active').removeClass('mobile-opened').removeClass('mobile-hide');
            $(activePane).closest('.tab-content').find('.tab-link.mobile-hide').removeClass('mobile-hide');
            $(activePane).removeClass('show').removeClass('active').removeClass('mobile-show');

            stepShow = 1;
            if ($(window).width() < 767 || openedAsPopup) {
                $('#help-center-title').show();
                $('#help-center-button').hide();
            }

        }

        if (stepShow == 3) {

            var activeColapse = $('#help-center-section').find('.collapse.show.mobile-show');
            var activePane = $('#help-center-section').find('.tab-pane.mobile-show');

            $(activeColapse).removeClass('show').removeClass('mobile-show');
            $(activeColapse).closest('.tab-pane').find('a.hc-option-name').addClass('collapsed').removeClass('mobile-opened').removeClass('mobile-hide');
            $(activeColapse).closest('.tab-pane').addClass('active').removeClass('mobile-hide').addClass('mobile-opened');

            $(activePane).prev('a.tab-link').removeClass('mobile-hide').addClass('active').addClass('mobile-opened');

            stepShow = 2;
        }


        return false;
    });

    $('#help-center-opener').on('click', 'a#close-btn-help-center', function (e) {

        $('#help-center-opener').empty().removeClass('opened');
        return false;
    });

}


$.append_notification = function (status, text_content) {


    var randomString = 'notification_' + Math.random().toString(36).substring(7);
    var notification_html = '<div class="border2 closable ' + status + ' notification slide_notification ' + randomString + '">' +
        '<a class="close_toast" href="javascript:;"><span class="fas fa-times"></span></a>' +
        '<p>' + text_content + '</p>' +
        '</div>';

    jQuery('#notification_content').prepend(notification_html);

    setTimeout(function () {
        jQuery('div.' + randomString).removeClass('slide_notification');
    }, 250);

    //trigger the automatic slideUp;
    $.hide_notification(jQuery('div.' + randomString));
}


$.hide_notification = function ($div, click) {
    click = (click) ? true : false;

    if (click) {
        trigger_hide_notification();
    } else {
        setTimeout(function () {
            trigger_hide_notification();
        }, 7000);
    }

    function trigger_hide_notification() {
        $div.addClass('slide_notification');
        setTimeout(function () {
            $div.remove();
        }, 300);
    }
}


function getStyledGoogleMap() {
    return new google.maps.StyledMapType(
        [
            {
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "administrative.country",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "lightness": 5
                    },
                    {
                        "weight": 1.5
                    }
                ]
            },
            {
                "featureType": "administrative.land_parcel",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#bdbdbd"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#edf0f5"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dadada"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "transit.line",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "transit.station",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#c9c9c9"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#d5dae2"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            }
        ],
        {name: 'Styled Map'});


}

function query_map(mapWrapper, query) {


    if ($('#' + mapWrapper).length > 0) {
        var geocoder = new google.maps.Geocoder();

        if (map) {
            geocoder.geocode({'address': query}, function (results, status) {
                if (status === 'OK') {
                    if ($('#displayAddress').length > 0){
                        var displayAddressValueTyped = $('#displayAddress').val();
                        if(displayAddressValueTyped.length < 16)
                            $('#displayAddress').val(results[0].formatted_address);

                    }

                    typedBeforeMarker = true;

                    addMarker(results[0].geometry.location, map, mapWrapper);
                    map.setCenter(results[0].geometry.location);
                    map.setZoom(11);


                    if (typeof fetchedZipList !== 'undefined' && !fetchedZipList.length && !$('#serviceArea').find('input').length) {
                        $.when($.initializeBloodhound(results[0].geometry.location.lat().toFixed(8), results[0].geometry.location.lng().toFixed(8))).then(function () {
                            $.when($.loadTagsinput()).then(function () {

                                $.each(fetchedZipList, function (i, k) {

                                    $('#serviceAreaSelect').tagsinput('add', k.text);
                                    var inputField = '<input type="hidden" id="serviceArea-' + k.text + '" name="serviceArea[]" value="' + this.value + '" data-zip="' + k.text + '" data-zcta="' + k.zcta_id + '" />';
                                    if (!$('#serviceArea').find('input[value="' + this.value + '"]'))
                                        $('#serviceArea').append(inputField);


                                });

                            });
                        });
                    }

                } else {

                    addMarker({lat: 29.92363800, lng: -95.55919000}, map, mapWrapper);
                    map.setCenter({lat: 29.92363800, lng: -95.55919000});
                    map.setZoom(9);
                }
            });

        }
    } else {

    }
}

function load_map(mapWrapper) {


    if (typeof styledMapType === 'undefined' || !styledMapType)
        var styledMapType = getStyledGoogleMap();

    if ($('#' + mapWrapper).length > 0) {
        //

        map = new google.maps.Map(document.getElementById(mapWrapper), {
            zoom: 9,
            center: {lat: 29.92363800, lng: -95.55919000},
            streetViewControl: false,
            fullscreenControl: false,
            mapTypeControl: false,
            mapTypeControlOptions: {
                mapTypeIds: ['styled_map']
            }
        });

        mapLoaded = true;

        map.mapTypes.set('styled_map', styledMapType);
        map.setMapTypeId('styled_map');

        google.maps.event.addListener(map, 'click', function (event) {
            if (markerPush) {

                var previousMarker = markers[mapWrapper];
                if (previousMarker && previousMarker[0])
                    var prevPos = previousMarker[0].getPosition();
                else
                    var prevPos = false;

                typedBeforeMarker = false;

                addMarker(event.latLng, map, mapWrapper);

                if (prevPos) {
                    var distance = google.maps.geometry.spherical.computeDistanceBetween(prevPos, event.latLng);
                    if (parseInt(distance) > 10000) {
                        $.when($.initializeBloodhound(event.latLng.lat().toFixed(8), event.latLng.lng().toFixed(8))).then(function () {
                            $('#serviceAreaSelect').tagsinput('removeAll');
                            $('#serviceAreaSelect').tagsinput('destroy');
                            $('#serviceArea').empty();
                            $.when($.loadTagsinput()).then(function () {

                                $.each(fetchedZipList, function (i, k) {
                                    if (k.distance <= 8) {
                                        $('#serviceAreaSelect').tagsinput('add', k.text);
                                        var inputField = '<input type="hidden" id="serviceArea-' + k.text + '" name="serviceArea[]" value="' + this.value + '" data-zip="' + k.text + '" data-zcta="' + k.zcta_id + '" />';
                                        if (!$('#serviceArea').find('input[value="' + this.value + '"]'))
                                            $('#serviceArea').append(inputField);

                                    }
                                });

                            });
                        });
                        // $.initializeBloodhound(event.latLng.lat().toFixed(8),event.latLng.lng().toFixed(8))
                    }
                }


            }

        });


    } else {
        alert('Geocode was not successful for the following reason: Missing Map Holder');
    }
}


// Adds a marker to the map.
function addMarker(location, map, mapWrapper) {
    setMapOnAll(mapWrapper);
    // Add the marker at the clicked location, and add the next-available label
    // from the array of alphabetical characters.
    // var iconimage = new google.maps.MarkerImage("../img/map-pointer2.png", null, null, null, new google.maps.Size(20,32));
    var marker = new google.maps.Marker({
        position: location,
        label: '',
        // icon: iconimage,
        draggable: true,
        map: map,
        animation: google.maps.Animation.DROP,
    });

    markers[mapWrapper] = [];
    markers[mapWrapper].push(marker);


    if ($('#' + mapWrapper).closest('#display-address-field').find('input#latitude').length > 0) {
        $('#' + mapWrapper).closest('#display-address-field').find('input#latitude').val(marker.getPosition().lat().toFixed(8));
    }
    if ($('#' + mapWrapper).closest('#display-address-field').find('input#longitude').length > 0) {
        $('#' + mapWrapper).closest('#display-address-field').find('input#longitude').val(marker.getPosition().lng().toFixed(8));
    }

    // console.log(typedBeforeMarker);

    // if(typedBeforeMarker){
    //     typedBeforeMarker = false;
    // }else{
        if ($('#' + mapWrapper).closest('#display-address-field').find('#displayAddress').length > 0) {
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({
                latLng: location
            }, function (responses) {
                $('#' + mapWrapper).closest('#display-address-field').find('#displayAddress').next('span.warning-feedback').html('<small style="font-size: 9px">'+responses[0].formatted_address+'</span>')
            });
        }
    // }

}

// Sets the map on all markers in the array.
function setMapOnAll(map) {
    if (markers[map] && markers[map].length > 0) {
        for (var i = 0; i < markers[map].length; i++) {
            markers[map][i].setMap(null);
        }
    }

}


jQuery.alerts = {

    // These properties can be read/written by accessing jQuery.alerts.propertyName from your scripts at any time

    verticalOffset: -75,                // vertical offset of the dialog from center screen, in pixels
    horizontalOffset: 0,                // horizontal offset of the dialog from center screen, in pixels/
    repositionOnResize: true,           // re-centers the dialog on window resize
    overlayOpacity: .7,                 // transparency level of overlay
    overlayColor: '#000',               // base color of overlay
    draggable: true,                    // make the dialogs draggable (requires UI Draggables plugin)
    manualPosition: false,              // position the window manually
    replaceNewRow: false,                // replace new row with <br />
    okButton: '&nbsp;OK&nbsp;',         // text for the OK button
    okDoubleButton: '&nbsp;OK Both&nbsp;',         // text for the OK button
    cancelButton: '&nbsp;Cancel&nbsp;', // text for the Cancel button
    dialogClass: null,                  // if specified, this class will be applied to all dialogs

    // Public methods

    alert: function (message, title, callback) {
        if (title == null) title = 'Alert';
        jQuery.alerts._show(title, message, null, 'alert', function (result, result1, result2) {
            if (callback) callback(result, result1, result2);
        });
    },

    confirmDouble: function (message, title, callback) {
        if (title == null) title = 'Confirm';
        jQuery.alerts._show(title, message, null, 'confirmDouble', function (result, result1, result2) {
            if (callback) callback(result, result1, result2);
        });
    },

    confirm: function (message, title, callback) {
        if (title == null) title = 'Confirm';
        jQuery.alerts._show(title, message, null, 'confirm', function (result, result1, result2) {
            if (callback) callback(result, result1, result2);
        });
    },

    prompt: function (message, value, title, callback) {
        if (title == null) title = 'Prompt';
        jQuery.alerts._show(title, message, value, 'prompt', function (result, result1, result2) {
            if (callback) callback(result, result1, result2);
        });
    },

    // Private methods

    _show: function (title, msg, value, type, callback) {

        jQuery.alerts._hide();
        jQuery.alerts._overlay('show');

        $("BODY").append(
            '<div id="popup_container">' +
            '<h1 id="popup_title"></h1>' +
            '<div id="popup_content">' +
            '<div id="popup_message"></div>' +
            '</div>' +
            '</div>');

        if (jQuery.alerts.dialogClass) $("#popup_container").addClass(jQuery.alerts.dialogClass);

        // IE6 Fix
        var pos = 'fixed';

        $("#popup_container").css({
            position: pos,
            zIndex: 99999,
            padding: 0,
            margin: 0
        });

        $("#popup_title").text(title);
        $("#popup_content").addClass(type);
        $("#popup_message").html(msg);

        if (jQuery.alerts.replaceNewRow)
            $("#popup_message").html($("#popup_message").text().replace(/\n/g, '<br />'));


        jQuery.alerts._reposition();
        jQuery.alerts._maintainPosition(true);

        switch (type) {
            case 'alert':
                $("#popup_message").after('<div id="popup_panel"><input type="button" value="' + jQuery.alerts.okButton + '" id="popup_ok" class="button btn btn-outline-primary" /></div>');
                $("#popup_ok").click(function () {
                    jQuery.alerts._hide();
                    callback(false, true, false);
                });
                $("#popup_ok").keypress(function (e) {
                    if (e.keyCode == 13 || e.keyCode == 27) $("#popup_ok").trigger('click');
                });
                break;
            case 'confirmDouble':
                $("#popup_message").after('<div id="popup_panel"><input type="button" value="' + jQuery.alerts.okDoubleButton + '" id="popup_ok_double" class="button btn btn-outline-primary" /><input type="button" value="' + jQuery.alerts.okButton + '" id="popup_ok" class="button btn btn-outline-primary" /><input type="button" value="' + jQuery.alerts.cancelButton + '" id="popup_cancel" class="button btn btn-outline-danger" /></div>');

                $("#popup_ok_double").click(function () {
                    jQuery.alerts._hide();
                    if (callback) callback(true, false, false);
                });

                $("#popup_ok").click(function () {
                    jQuery.alerts._hide();
                    if (callback) callback(false, true, false);
                });
                $("#popup_cancel").click(function () {
                    jQuery.alerts._hide();
                    if (callback) callback(false, false, false);
                });


                $("#popup_cancel").keypress(function (e) {
                    if (e.keyCode == 27) $("#popup_cancel").trigger('click');
                });
                break;
            case 'confirm':
                $("#popup_message").after('<div id="popup_panel"><input type="button" value="' + jQuery.alerts.okButton + '" id="popup_ok" class="button btn btn-outline-primary" /> <input type="button" value="' + jQuery.alerts.cancelButton + '" id="popup_cancel" class="button btn btn-outline-danger" /></div>');
                $("#popup_ok").click(function () {
                    jQuery.alerts._hide();
                    if (callback) callback(true);
                });
                $("#popup_cancel").click(function () {
                    jQuery.alerts._hide();
                    if (callback) callback(false);
                });

                $("#popup_ok, #popup_cancel").keypress(function (e) {
                    if (e.keyCode == 13) $("#popup_ok").trigger('click');
                    if (e.keyCode == 27) $("#popup_cancel").trigger('click');
                });
                break;
            case 'prompt':
                $("#popup_message").append('<br /><input type="text" size="30" id="popup_prompt" />').after('<div id="popup_panel"><input type="button" value="' + jQuery.alerts.okButton + '" id="popup_ok" class="button btn btn-outline-primary" /> <input type="button" value="' + jQuery.alerts.cancelButton + '" id="popup_cancel" class="button btn btn-outline-danger" /></div>');

                if (!jQuery.alerts.manualPosition) {
                    $("#popup_prompt").width($("#popup_message").width());
                }

                $("#popup_ok").click(function () {
                    var val = $("#popup_prompt").val();
                    jQuery.alerts._hide();
                    if (callback) callback(val);
                });
                $("#popup_cancel").click(function () {
                    jQuery.alerts._hide();
                    if (callback) callback(null);
                });
                $("#popup_prompt, #popup_ok, #popup_cancel").keypress(function (e) {
                    if (e.keyCode == 13) $("#popup_ok").trigger('click');
                    if (e.keyCode == 27) $("#popup_cancel").trigger('click');
                });
                if (value) $("#popup_prompt").attr('placeholder', value);
                $("#popup_prompt").select();
                break;
        }

        if (!jQuery.alerts.manualPosition) {
            $("#popup_container").css({
                minWidth: $("#popup_container").outerWidth(true),
                maxWidth: $("#popup_container").outerWidth(true)
            });
        }

        // Make draggable
        if (jQuery.alerts.draggable) {
            try {
                $("#popup_container").draggable({handle: $("#popup_title")});
                $("#popup_title").css({cursor: 'move'});
            } catch (e) { /* requires jQuery UI draggables */
            }
        }
    },

    _hide: function () {
        $("#popup_container").remove();
        jQuery.alerts._overlay('hide');
        jQuery.alerts._maintainPosition(false);
    },

    _overlay: function (status) {
        switch (status) {
            case 'show':
                jQuery.alerts._overlay('hide');
                $("BODY").append('<div id="popup_overlay"></div>');

                $("#popup_overlay").css({
                    position: 'fixed',
                    zIndex: 99998,
                    background: jQuery.alerts.overlayColor,
                    opacity: jQuery.alerts.overlayOpacity,
                    top: '0px',
                    left: '0px',
                    width: '100%',
                    height: $(document).height()
                });
                break;
            case 'hide':
                $("#popup_overlay").remove();
                break;
        }
    },

    _reposition: function () {
        if (!jQuery.alerts.manualPosition) {
            var top = (($(window).height() / 2) - ($("#popup_container").outerHeight(true) / 2)) + jQuery.alerts.verticalOffset;
            var left = (($(window).width() / 2) - ($("#popup_container").outerWidth(true) / 2)) + jQuery.alerts.horizontalOffset;
            if (top < 0) top = 0;
            if (left < 0) left = 0;

            // IE6 fix
            // if( jQuery.browser.msie && parseInt(jQuery.browser.version) <= 6 ) top = top + $(window).scrollTop();

            $("#popup_container").css({
                top: top + 'px',
                left: left + 'px'
            });
        }
        $("#popup_overlay").height($(document).height());
    },

    _maintainPosition: function (status) {
        if (jQuery.alerts.repositionOnResize) {
            switch (status) {
                case true:
                    $(window).bind('resize', jQuery.alerts._reposition);
                    break;
                case false:
                    $(window).unbind('resize', jQuery.alerts._reposition);
                    break;
            }
        }
    }

}

// Shortcut functions
jQuery.jAlert = function (message, title, callback) {
    jQuery.alerts.alert(message, title, callback);
}

jQuery.jConfirm = function (message, title, callback) {
    jQuery.alerts.confirm(message, title, callback);
};

jQuery.jConfirmDouble = function (message, title, callback) {
    jQuery.alerts.confirmDouble(message, title, callback);
};

jQuery.jPrompt = function (message, value, title, callback) {
    jQuery.alerts.prompt(message, value, title, callback);
};


jQuery.fn.validate = function (rules, callback) {
    var FUNCTIONS = {
        bigger: function (object, rule) {

            if (jQuery(object).val() > rule)
                return true;
            return false;
        },
        longer: function (object, rule) {
            var value = jQuery(object).val();
            if (value.length > rule)
                return true;
            return false;
        },
        shorter: function (object, rule) {
            var value = jQuery(object).val();
            if (value.length < rule)
                return true;
            return false;
        },
        eq: function (object, rule) {

            var value = jQuery(object).val();
            if (value.length < rule)
                return true;
            return false;
        },
        validEmail: function (object, rule) {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(jQuery(object).val());
        },
        lesser: function (object, rule) {
            if (jQuery(object).val() < rule) return true;
            return false;
        },
        equal: function (object, rule) {
            if (jQuery(object).val() == rule) return true;
            return false;
        },
        compareToPassConf: function (object, rule) {
            if (jQuery(object).val().toString() == jQuery('#' + rule).val().toString()) return true;
            return false;
        },
        isChecked: function (object, rule) {
            if (jQuery(object).prop('checked')) {
                jQuery(object).val('1');
            } else {
                jQuery(object).val('');
            }
        },
        hasValue: function (object, rule) {
            var value = jQuery(object).val();

            if (!value || value == '' || value == ' ' || value == null || typeof value == 'undefined')
                return false;
            else
                return true;
        },
        isInt: function (object, rule) {
            var value = jQuery(object).val();
            if (rule == '1') {
                return parseInt(value) % 1 == 0;
            } else
                return !(parseInt(value) % 1 == 0);
        }
    };

    var data_rules = jQuery(this).attr('data-rules') || '',
        rules = rules || {};

    var rules_split = data_rules.split(';');
    jQuery.each(rules_split, function (i, rule) {
        var matches = rule.split(':');
        if (matches[0] && matches[1])
            rules[matches[0]] = matches[1];
    });

    if (!jQuery.isEmptyObject(rules)) {

        var rArray = [true],
            that = this;

        jQuery.each(rules, function (aRule, aValue) {
            var callee = FUNCTIONS[aRule];
            if (callee)
                rArray.push(callee(that, aValue));
        });

        return (jQuery.inArray(false, rArray) == -1);
    } else {
        return true;
    }

}

jQuery.fn.executeValidation = function () {

    var validArray = [],
        message = '',
        o = {},
        valid = true;


    jQuery(this).each(function (i, k) {

        var validation = jQuery(k).validate(),
            data_validation_message = jQuery(k).attr('data-validation-message');

        if (!validation) {
            jQuery(k).addClass('not-valid');
            message += '<p>' + data_validation_message + '</p>';
        } else {
            jQuery(k).removeClass('not-valid');
        }

        var name = jQuery(k).attr('name'),
            val = jQuery(k).val();

        if (o[name]) {
            if (!o[name].push) {
                o[name] = [o[name]];
            }
            o[name].push(val || '');
        } else {
            o[name] = val || '';
        }

        validArray.push({
            'dom': k,
            'valid': validation,
            'message': data_validation_message
        });

    });

    jQuery.each(validArray, function (i, k) {
        if (!k.valid) {
            valid = false;
            return false;
        }
    });
    return {'status': valid, 'message': message, 'validArray': validArray, 'o': o};
}

$.multiArrayReturn = function (arr, search_obj_key_name, search_obj_key_val, return_type, search_obj_key_int, return_arr) {
    var result = false;
    var result_arr = [];
    $.each(arr, function (i, k) {
        if (typeof return_arr != 'undefined' && typeof k[search_obj_key_name] != 'undefined') {
            if (typeof search_obj_key_int != 'undefined' && $.inArray(parseInt(k[search_obj_key_name]), search_obj_key_val) > -1)
                result_arr.push(k);
            else if ($.inArray(k[search_obj_key_name], search_obj_key_val) > -1)
                result_arr.push(k);
        } else if (typeof k[search_obj_key_name] != 'undefined') {
            if (typeof search_obj_key_int != 'undefined' && parseInt(k[search_obj_key_name]) == search_obj_key_val) {
                result = arr[i];
                // result_arr[i] = arr[i];
                result_arr.push(arr[i]);
            } else if (k[search_obj_key_name] == search_obj_key_val) {
                result = arr[i];
                // result_arr[i] = arr[i];
                result_arr.push(arr[i]);
            }
        }
    });

    if (typeof return_arr != 'undefined')
        return result_arr;
    else {
        // Return type defines should i return all results or just one result
        if (return_type)
            return result_arr;
        else
            return result;
    }
}


$.getStyledGoogleMap = function () {
    return new google.maps.StyledMapType(
        [
            {
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "administrative.country",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "lightness": 5
                    },
                    {
                        "weight": 1.5
                    }
                ]
            },
            {
                "featureType": "administrative.land_parcel",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#bdbdbd"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#edf0f5"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dadada"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "transit.line",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "transit.station",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#c9c9c9"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#d5dae2"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            }
        ],
        {name: 'Styled Map'});


}
